var map = {
	"./templateLoader": 9,
	"./templateLoader.js": 9,
	"./templateLoaderIndirect": 8,
	"./templateLoaderIndirect.js": 8,
	"./tmpl": 10,
	"./tmpl.js": 10
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.id = 4;
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;



/*****************
 ** WEBPACK FOOTER
 ** ./parsing/context/templates ^\.\/t.*$
 ** module id = 4
 ** module chunks = 0
 **/